import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FindLoad, Images, useModal, useSecondaryModal,  } from 'utils';
import { CloseButton, Loader } from 'components';
import { NotesMultipleCard } from './notesMultipleCard';
import { noteActions } from 'store';
import button from 'react-rte/lib/ui/Button';
import { NotesMultipleAdd } from './notesMultipleAdd';
import { CustomDeleteModal } from '../modals';

const ACTION_TYPE = 'GET_GLOBAL_NOTES';
const DELETE_ACTION_TYPE = 'DELETE_GLOBAL_NOTE';

export const NotesMultipleModal = ({ id, commentType, svgSrc }) => {
  const notes = useSelector((state) => state.note.notes);
  const dispatch = useDispatch();
  const { open, close } = useModal();
  const { closeSecondary } = useSecondaryModal();
  const loading = FindLoad(ACTION_TYPE);

  useEffect(() => {
    const pushInfo = {
      skip: 0,
      limit: 1000,
      type: commentType,
    };
    dispatch(noteActions.getGlobalNotes(id, { ...pushInfo }));
  }, [commentType]);

  const changeNotes = (note) => {
    open(
      <NotesMultipleAdd
        currentId={id}
        commentType={commentType}
        info={note}
      />,
      { noPadding: true, noCloseButton: true },
    );
  };

  const handleDeleteNote = (currentId) => {
    open(
      <CustomDeleteModal
        afterSuccess={close}
        actionType={DELETE_ACTION_TYPE}
        text='Delete note?'
        info={'Note'}
        handleDel={() => {
          dispatch(noteActions.deleteGlobalNote(currentId, id, commentType));
        }}
      />,
    );
  };

  return (
    <div className='notes-multiple-modal-wrapper'>
      <div className='notes-multiple-modal-header'>
        <p className='notes-multiple-modal-title'>
          Correction Notes
        </p>

        <div className='notes-multiple-modal-actions'>
          <button
            className='notes-multiple-modal-add-button'
            onClick={() => changeNotes()}
          >
            <div className='notes-multiple-modal-add-button-icon'>
              <img src={Images.addWhiteIcon} alt={'icon'} />
            </div>

            <p className='notes-multiple-modal-add-button-text'>
              Add Note
            </p>
          </button>

          <CloseButton handleCLic={closeSecondary} />
        </div>
      </div>

      <div className='notes-multiple-modal-body'>
        {loading?.length ?
          <Loader height={'100%'} />
          : !!notes?.length && notes?.map((note) => (
          <NotesMultipleCard
            key={note?.id}
            note={note}
            svgSrc={svgSrc}
            handleEditNote={() => changeNotes(note)}
            handleDeleteNote={() => handleDeleteNote(note?.id)}
          />
        ))
        }
      </div>
    </div>
  );
};

